// extracted by mini-css-extract-plugin
export default {"dragDropContainer":"FileDragDrop_dragDropContainer__dvjoM","draggingContainer":"FileDragDrop_draggingContainer__UxBJE","draggingContent":"FileDragDrop_draggingContent__Aq+Bt"};